<template>
<div id="puzzle-search">
  <form
    :action="this.searchUrl"
    method="post"
    v-on:submit.prevent="search"
  >
    <h4>Puzzle Search</h4>

    <div class="form-group row">
      <div class="sr-only">
        <label
          for="puzzle-name"
          class="col-form-label"
        >
          Name
        </label>
      </div>
      <div class="col-4">
        <input
          type="text"
          name="name"
          id="puzzle-name"
          class="form-control"
          placeholder="Search By Puzzle Name"
          v-model="puzzleName"
        />
      </div>
      <div class="col-sm-1">
        <label
          for="puzzle-date"
          class="col-form-label"
        >
          Date
        </label>
      </div>
      <div class="col-3">
        <input
          type="date"
          name="date"
          id="puzzle-date"
          class="form-control"
          v-model="puzzleDate"
        />
      </div>
      <div class="col-4">
        <button
          type="submit"
          class="btn btn-primary"
          v-on:click.prevent="search"
        >
          Find Puzzles
        </button>
      </div>
    </div>

    <div v-if="puzzles.length > 0">
      <ol>
        <li v-for="puzzle in puzzles">
          <a href="#"
            :data-puzzle-id="puzzle.id"
            :data-puzzle-name="puzzle.name"
            v-on:click.prevent="selectResult"
          >
            Puzzle {{ puzzle.name }} #{{ puzzle.id }}
          </a>
        </li>
      </ol>
    </div>
    <p
      class="alert alert-warning"
      v-else-if="searched"
    >
      No Puzzles Found
    </p>
  </form>
</div>

</template>
<script>
import PuzzlesStore from '@/stores/PuzzlesStore'
export default {
  data () {
    let state = PuzzlesStore.state
    state.puzzleName = undefined
    state.puzzleDate = undefined
    state.searched = false

    return state
  },

  computed: {
    searchUrl () {
      return this.apiUrl('/puzzles/search', true)
    }
  },

  methods: {
    search (ev) {
      this.$http.post(this.searchUrl, {
        name: this.puzzleName,
        date: this.puzzleDate
      }).then((resp) => {
        this.$parent.$emit('searchComplete', this.processSuccess(resp))
        this.puzzles = this.processSuccess(resp)
        this.searched = true
      }, this.processErrors)
    },

    selectResult (ev) {
      ev.preventDefault()

      const ele = ev.target
      this.$parent.$emit('searchResultClicked', {
        id: ele.dataset.puzzleId,
        name: ele.dataset.puzzleName
      })

      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PuzzleSearch.vue